import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'お知らせタイプ',

  // model
  noticeTypeMstModel: [],
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {noticeTypeMstParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['noticeTypeMst'],
        ['v1NoticeTypeMstListGet'],
        [noticeTypeMstParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setNoticeTypeMstModel', res[0].data.noticeTypeMsts)
            console.log('noticeTypeMstModel', state.noticeTypeMstModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.NoticeTypeMstId)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setNoticeTypeMstModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'noticeTypeMstModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpNoticeTypeName', null)
    Vue.set(state.values, 'inpNoticeType', null)
    Vue.set(state.values, 'inpScreenIdMstId', null)
    Vue.set(state.values, 'inpStatus', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpNoticeTypeName', data.noticeTypeName)
    Vue.set(state.values, 'inpNoticeType', data.noticeType)
    Vue.set(state.values, 'inpScreenIdMstId', data.screenIdMstUuid)
    Vue.set(state.values, 'inpStatus', data.noticeTypeStatus)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
